/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Top_Left_TitleInputs */



/**
* | output |
* | --- |
* | "Position: Top Left" |
*
* @param {Position_Top_Left_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_top_left_title = /** @type {((inputs?: Position_Top_Left_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Top_Left_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position : En Haut a Gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position: Oben links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione: in alto a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция: Верхний левый угол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición: Arriba a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：左上")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置: 左上")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति: ऊपर बाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Superior Esquerda")
	return /** @type {LocalizedString} */ ("Position: Top Left")
});